module.exports = __webpack_public_path__ + "static/media/speakers_logos_HKBU.65f7fd8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_HKBU.jpg
// module id = 268
// module chunks = 0